import { render, staticRenderFns } from "./imageRegionWrapper.vue?vue&type=template&id=708eb516&scoped=true&"
import script from "./imageRegionWrapper.vue?vue&type=script&lang=js&"
export * from "./imageRegionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./imageRegionWrapper.vue?vue&type=style&index=0&id=708eb516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708eb516",
  null
  
)

export default component.exports